<script setup></script>

<template>
  <div v-if="file?.service || file?.service?.url" class="mb-1">
    <hawk-attachments-grid
      :need_manual_trigger="true"
      :items="[file]"
      :grouped_items="form$.data[el$.fieldId.split('.')[0]]"
      :can_delete="true"
      :enable_description="true"
      :show_edit_icon="el$.parent?.options?.show_edit_icon !== false"
      @update-notes="updateNotesHandler"
      @delete="remove"
    />
  </div>
  <div
    v-else-if="file?.name"
    class="flex p-3 border mb-2 rounded-lg relative group/attachment"
    :class="is_error?.value || file?.has_unsupported_extension ? 'border-red-600' : progress.value === 100 ? 'border-primary-600' : 'border-gray-200'"
  >
    <div v-if="is_error?.value || file?.has_unsupported_extension" class="flex align-center absolute top-0 left-0 w-full h-full">
      <div class="h-full w-full rounded-lg bg-error-25" />
    </div>
    <div v-else-if="progress && progress.value !== 0" class="flex align-center absolute top-0 left-0 w-full h-full ">
      <div class="h-full rounded-lg bg-gray-50" :style="`width:${progress && progress.value}%;`" />
    </div>
    <div v-if="el$.use_uppy" class="pr-1 z-1">
      <div v-if="file?.has_unsupported_extension" class="flex item-center justify-center w-10 pt-2 text-error-600 text-xl">
        <IconHawkAlertTriangle />
      </div>
      <div v-else-if="is_error?.value" class="flex item-center justify-center w-10 pt-2 text-error-600 text-xl cursor-pointer" @click="reupload">
        <IconHawkRefreshCcwOne />
      </div>
      <div v-else-if="progress.value === 100" class="flex item-center justify-center w-10 pt-2 text-primary-600 text-xl">
        <IconHawkCheck />
      </div>
      <hawk-progress-ring v-else :radius="20" :progress="progress.value" :stroke="4" />
    </div>
    <div v-else class="pr-1 relative">
      <IconHawkUploadFileIcon class="w-10 h-10" />
    </div>
    <div class="flex-1 relative">
      <div class="flex">
        <div class="flex-1">
          <template v-if="is_name_editable">
            <div
              v-click-outside="() => is_name_editable = false"
              class="w-[352px] z-10 absolute right-0 top-10 shadow-md p-4 bottom-50 rounded-lg bg-white border border-gray-200"
            >
              <textarea
                id="notes"
                ref="text_area_ref"
                v-model.trim="input_notes"
                class="w-full resize-none text-gray-700 placeholder-gray-500 text-sm p-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-4 focus:ring-primary-500 focus:ring-opacity-30 focus:border-primary-500 transition"
                :placeholder="$t('Add description')"
                rows="3"
              />
              <div class="mt-4 w-full flex items-center justify-between gap-4">
                <HawkButton
                  type="outlined"
                  :block="true"
                  @click.stop="is_name_editable = false"
                >
                  {{ $t('Cancel') }}
                </HawkButton>
                <HawkButton
                  :block="true"
                  @click.stop="() => { updateNotesHandler({ notes: input_notes }); is_name_editable = false }"
                >
                  {{ $t('Save') }}
                </HawkButton>
              </div>
            </div>
          </template>
          <div class="flex items-center gap-2">
            <hawk-text :content="file.notes || file.name" :length="30" class="text-gray-700" type="truncateMiddle" />
            <IconHawkEdit
              v-if="el$.parent?.options?.show_edit_icon !== false && !is_name_editable && progress.value === 100 && !is_uploading"
              class="shrink-0 text-primary w-3 h-3 cursor-pointer invisible group-hover/attachment:visible"
              @click.stop="is_name_editable = true"
            />
          </div>
          <div v-if="file?.has_unsupported_extension" class="subtitle_text text-gray-600 font-normal text-sm">
            {{ $t("It seems like you're trying to upload an unsupported file type. Please try again with a supported file format.") }}
          </div>
          <div v-else-if="el$.use_uppy" class="subtitle_text text-gray-600 font-normal text-sm">
            {{ numberToBytes(file.size) }} - {{ progress.value }}% {{ $t('uploaded') }}
          </div>
          <div v-else class="subtitle_text text-gray-600 font-normal text-sm">
            {{ numberToBytes(file.size) }}
          </div>
        </div>
        <div
          class="flex p-2 text-lg rounded-md text-danger h-fit"
          :class="!is_uploading || file?.has_unsupported_extension ? 'hover:bg-gray-100 cursor-pointer' : ''"
          v-on="!is_uploading || file?.has_unsupported_extension ? { click: remove } : {}"
        >
          <IconHawkXClose class="text-gray-500" :class="!is_uploading || file?.has_unsupported_extension ? '' : 'invisible'" />
        </div>
      </div>
    </div>
  </div>
</template>
